import Service from "@/services";

export default {
  namespaced: true,
  state: {
    walletData: {
      user: null,
      walletData: null,
    },
    transactions: [],
    transactionsMeta: {
      current_page: 1,
      last_page: 1,
      total: 0,
      per_page: 10,
    },
    isLoading: false,
    error: null,
  },
  getters: {
    walletData: (state) => state.walletData,
    transactions: (state) => state.transactions,
    transactionsMeta: (state) => state.transactionsMeta,
    isLoading: (state) => state.isLoading,
    error: (state) => state.error,
    walletBalance: (state) => state.walletData?.walletData?.balance || 0,
    verificationStatus: (state) =>
      state.walletData?.user?.verified || "unverified",
  },
  actions: {
    async getWalletData({ commit }) {
      commit("SET_LOADING", true);
      try {
        const res = await Service().get("../api/auth/user-wallet");
        commit("SET_WALLET_DATA", res.data.data);
        commit("SET_LOADING", false);
        return res.data;
      } catch (e) {
        console.log("Error fetching wallet data: ", e);
        commit("SET_ERROR", e.message || "Failed to load wallet data");
        commit("SET_LOADING", false);
        return e;
      }
    },

    async submitAccountVerification({ commit }, payload) {
      commit("SET_LOADING", true);
      try {
        const res = await Service().post(
          "../api/wallet/verify-account",
          payload
        );
        console.log("Account verification response: ", res);

        // If verification successful, update wallet data with new verification status
        if (res.data && res.data.status) {
          // Update the verification status in the wallet data
          commit("UPDATE_VERIFICATION_STATUS", "pending");
        }

        commit("SET_LOADING", false);
        return res;
      } catch (e) {
        console.log("Error submitting verification: ", e);
        commit(
          "SET_ERROR",
          e.response?.data?.message || "Verification submission failed"
        );
        commit("SET_LOADING", false);
        return e;
      }
    },

    async requestPhoneOTP({ commit }, payload) {
      commit("SET_LOADING", true);
      try {
        const res = await Service().post(
          "../api/wallet/request-phone-otp",
          payload
        );
        commit("SET_LOADING", false);
        return res;
      } catch (e) {
        console.log("Error requesting phone OTP: ", e);
        commit("SET_ERROR", e.response?.data?.message || "Failed to send OTP");
        commit("SET_LOADING", false);
        return {
          status: false,
          message: e.response?.data?.message || "Failed to send OTP",
        };
      }
    },

    async requestEmailOTP({ commit }, payload) {
      commit("SET_LOADING", true);
      try {
        const res = await Service().post(
          "../api/wallet/request-email-otp",
          payload
        );
        commit("SET_LOADING", false);
        return res;
      } catch (e) {
        console.log("Error requesting email OTP: ", e);
        commit("SET_ERROR", e.message || "Error requesting OTP");
        commit("SET_LOADING", false);
        return {
          status: false,
          message: e.message || "Error requesting OTP",
        };
      }
    },

    async submitWithdrawalRequest({ commit }, payload) {
      commit("SET_LOADING", true);
      try {
        const res = await Service().post("../api/wallet/withdraw", payload);
        commit("SET_LOADING", false);
        return res;
      } catch (e) {
        console.log("Error submitting withdrawal request: ", e);
        commit(
          "SET_ERROR",
          e.response?.data?.message || "Failed to submit withdrawal request"
        );
        commit("SET_LOADING", false);
        return {
          status: false,
          message:
            e.response?.data?.message || "Failed to submit withdrawal request",
        };
      }
    },

    async getWalletTransactions(
      { commit },
      { page = 1, perPage = 10, search = "" }
    ) {
      commit("SET_LOADING", true);
      try {
        const response = await Service().post("../api/wallet/transactions", {
          page,
          perPage,
          search,
        });

        if (response.data && response.data.status) {
          commit("SET_TRANSACTIONS", {
            transactions: response.data.data,
            meta: response.data.meta,
          });
        }

        commit("SET_LOADING", false);
        return response;
      } catch (e) {
        console.error("Error getting wallet transactions:", e);
        commit(
          "SET_ERROR",
          e.response?.data?.message || "Failed to load transactions"
        );
        commit("SET_LOADING", false);
        return {
          status: false,
          message: e.response?.data?.message || "Failed to load transactions",
          data: [],
          meta: {
            current_page: 1,
            last_page: 1,
            total: 0,
            per_page: perPage,
          },
        };
      }
    },
  },
  mutations: {
    SET_WALLET_DATA: (state, payload) => (state.walletData = payload),
    UPDATE_VERIFICATION_STATUS: (state, status) => {
      if (state.walletData && state.walletData.user) {
        state.walletData.user.verified = status;
      }
    },
    SET_TRANSACTIONS: (state, { transactions, meta }) => {
      state.transactions = transactions;
      state.transactionsMeta = meta;
    },
    SET_LOADING: (state, isLoading) => {
      state.isLoading = isLoading;
    },
    SET_ERROR: (state, error) => {
      state.error = error;
    },
    CLEAR_ERROR: (state) => {
      state.error = null;
    },
  },
};
